var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-slider',{attrs:{"tick-labels":_vm.tickLabels,"min":"0","max":_vm.tickLabels.length-1,"tick-size":"4","color":"secondary"},model:{value:(_vm.sliderValue),callback:function ($$v) {_vm.sliderValue=$$v},expression:"sliderValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }